/**
 * Mixin kroków kreatora
 */
export function wizardStepMixin(moduleName, step = 0) {
  return {
    methods: {
      // @vuese
      // Funkcja wywoływana wykonaniu zapisu
      afterSave(id) {
        this.$router.push({ params: { [`${moduleName}Id`]: id } });
        this.$emit('nextTab', id);
      },
      // @vuese
      // Przechodzi do listy po wykonaniu steppera
      backToList() {
        this.$router.push({ name: `${moduleName}s` });
      }
    },
    mounted() {
      this.$emit('setActiveTab', step);
    }
  };
}
